import { Button, Divider, notification, message, Form, InputNumber, Modal, Select } from 'antd';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import {
    fetchArticlesByCodes,
    fetchOrdersForClient,
    fetchCurrentCustomerDetails,
    fetchOrder,
    fetchDeliveryDeadlines,
    fetchOrderType,
    addLineToOrder,
    updateLineInOrder
} from '../../utils/apiBucherVaslin';
import PropTypes from 'prop-types';
import { isGroupEBV } from '../../utils/helpers';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import CreateOrder from '../Orders/CreateOrder';
import TablePDRAffichage from './TablePDRAffichage';
import './GedCatalog.less';

const { Option } = Select;

class TablePDRGedCatalog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pdrDocument: [],
            selectedRowKeys: [],
            fileState: props.file,
            ordersDraft: [],
            orderLine: [],
            visible: false,
            selectedOrder: null,
            clientInfo: null,
            loading: false,
            sawOnlyPrixPublic: true
        };
    }

    componentDidMount() {
        fetchCurrentCustomerDetails().then(({ clientInfo }) => {
            this.setState({
                clientInfo
            });
        });
        this.fetchOrdersClient();

        if (this.props.registerActions) {
            this.props.registerActions({ openConsultOrder: this.getCommandePrixPublic });
        }
    }

    componentDidUpdate(prevProps) {
        const { fileState } = this.state;
        const { file } = this.props;

        if (file && (!fileState || file.Id !== fileState.Id)) {
            this.setState({ fileState: file, pdrDocument: [] });
        }
    }

    onCancel = () => {
        this.setState({ visible: false, sawOnlyPrixPublic: true, selectedOrder: null });
    };

    onOk = () => {
        this.setState({ visible: false });
        this.fetchArticleOrder();
    };

    onOrderChanged = (value) => {
        this.setState({ selectedOrder: value });
        this.fetchArticlesFromFile(value);
    };

    fetchOrdersClient = async () => {
        const { clientID, intl } = this.props;
        const { items, isSuccess, isUnauthorized, errorDetail } = await fetchOrdersForClient(clientID)();

        if (isSuccess) {
            const ordersDraft = items.filter(x => x.statutCommand === "Draft");
            this.setState({ ordersDraft });

            await this.initOrderType();
            await this.initDeliveryDeadlines();
        } else {
            notification.error({
                message: isUnauthorized
                    ? intl.formatMessage({ id: 'error.unauthorized.title' })
                    : intl.formatMessage({ id: 'common.error' }),
                description: isUnauthorized
                    ? intl.formatMessage({ id: 'error.unauthorized.message' })
                    : errorDetail
            });
        }
    };

    initOrderType = async () => {
        const { intl } = this.props;
        const { ordersDraft } = this.state;

        const { orderType, isSuccess, isUnauthorized, errorDetail } = await fetchOrderType();

        if (!isSuccess) {
            notification.error({
                message: isUnauthorized
                    ? intl.formatMessage({ id: 'error.unauthorized.title' })
                    : intl.formatMessage({ id: 'common.error' }),
                description: isUnauthorized
                    ? intl.formatMessage({ id: 'error.unauthorized.message' })
                    : errorDetail
            });
            return;
        }

        for (let i = 0; i < ordersDraft.length; i++) {
            const orderTypeToGet = orderType.filter((ot) => ot.id === ordersDraft[i].typeCommandeId);
            ordersDraft[i].libelleTypeCommande = orderTypeToGet[0].libelleTypeByLangUser;
        }
        this.setState({ ordersDraft });
    };

    initDeliveryDeadlines = async () => {
        const { intl } = this.props;
        const { ordersDraft } = this.state;

        const { deliveryDeadlines, isSuccess, isUnauthorized, errorDetail } = await fetchDeliveryDeadlines();

        if (!isSuccess) {
            notification.error({
                message: isUnauthorized
                    ? intl.formatMessage({ id: 'error.unauthorized.title' })
                    : intl.formatMessage({ id: 'common.error' }),
                description: isUnauthorized
                    ? intl.formatMessage({ id: 'error.unauthorized.message' })
                    : errorDetail
            });
            return;
        }

        for (let i = 0; i < ordersDraft.length; i++) {
            const deliveryToGet = deliveryDeadlines.filter(
                (dd) => dd.id === ordersDraft[i].delaiLivraisonId
            );
            if (deliveryToGet[0]) {
                ordersDraft[i].libelleDeadlines = deliveryToGet[0].libelleByLangUser;
            }
        }
        this.setState({ ordersDraft });
    };

    getCommandeAndCreateLine = () => {
        const { ordersDraft } = this.state;
        const selectedOrder = ordersDraft.length > 0 ? ordersDraft[0].numCommande : '';
        
        this.setState({ sawOnlyPrixPublic: false, visible: true, selectedOrder });
        if(selectedOrder === '') { return; }
        this.fetchArticlesFromFile(selectedOrder);
    };

    getCommandePrixPublic = () => {
        this.setState({ visible: true });
        this.fetchArticlesFromFile(null);
    };

    fetchArticlesFromFile = async (selectedOrder) => {
        const { intl } = this.props;
        const { fileState } = this.state;

        if (!fileState || !fileState.Desc) {
            notification.warning({
                message: intl.formatMessage({ id: 'catalog.tablePdr.noArticles' })
            });
            return;
        }

        this.setState({ loading: true });

        try {
            // Parser les codes articles du champ Desc (séparés par |)
            const articleCodes = fileState.Desc.split('|')
                .map(code => code.trim())
                .filter(code => code.length > 0);

            if (articleCodes.length === 0) {
                notification.warning({
                    message: intl.formatMessage({ id: 'catalog.tablePdr.noArticles' })
                });
                this.setState({ loading: false, pdrDocument: [] });
                return;
            }

            const { isSuccess, articles, isUnauthorized, errorDetail } = await fetchArticlesByCodes(fileState.Desc, selectedOrder);

            if (!isSuccess) {
                notification.error({
                    message: isUnauthorized
                        ? intl.formatMessage({ id: 'error.unauthorized.title' })
                        : intl.formatMessage({ id: 'common.error' }),
                    description: isUnauthorized
                        ? intl.formatMessage({ id: 'error.unauthorized.message' })
                        : errorDetail
                });
                this.setState({ loading: false });
                return;
            }

            this.setState({ pdrDocument: articles || [], loading: false });
        } catch (error) {
            notification.error({
                message: intl.formatMessage({ id: 'common.error' }),
                description: error.message
            });
            this.setState({ loading: false });
        }
    };

    fetchArticleOrder = async () => {
        const { intl } = this.props;
        const { selectedOrder } = this.state;

        const { items, isSuccess: isSuccessOrder, isUnauthorized, errorDetail } = await fetchOrder(selectedOrder)();

        if (!isSuccessOrder) {
            notification.error({
                message: isUnauthorized
                    ? intl.formatMessage({ id: 'error.unauthorized.title' })
                    : intl.formatMessage({ id: 'common.error' }),
                description: isUnauthorized
                    ? intl.formatMessage({ id: 'error.unauthorized.message' })
                    : errorDetail
            });
        }

        this.setState({ orderLine: items.lignes });
        this.createCommande();
    };

    createCommande = async () => {
        const { pdrDocument, orderLine, selectedOrder } = this.state;
        const { intl } = this.props;

        for (let i = 0; i < pdrDocument.length; i++) {
            const quantiteArticle = this.props.form.getFieldValue('quantity_' + pdrDocument[i].codeArticle);

            if (quantiteArticle > 0) {
                const acctualCodeArticle = pdrDocument[i].codeArticle;

                if (pdrDocument[i]) {
                    const { isSuccess, isUnauthorized, errorDetail } = await addLineToOrder(
                        selectedOrder,
                        pdrDocument[i],
                        quantiteArticle
                    );

                    if (!isSuccess) {
                        notification.error({
                            message: isUnauthorized
                                ? intl.formatMessage({ id: 'error.unauthorized.title' })
                                : intl.formatMessage({ id: 'common.error' }),
                            description: isUnauthorized
                                ? intl.formatMessage({ id: 'error.unauthorized.message' })
                                : errorDetail
                        });
                    } else {
                        message.success(
                            intl.formatMessage(
                                {
                                    id: 'order.article.add'
                                },
                                { selectedOrder, acctualCodeArticle }
                            ),
                            4
                        );
                    }
                }
            }
        }
    };

    updateQuantity = (rawId) => {
        const { getFieldDecorator } = this.props.form;
        return getFieldDecorator('quantity_' + rawId, {
            initialValue: 0
        })(<InputNumber className="inputPDRQuantity" min={0} />);
    };

    render() {
        const { pdrDocument, ordersDraft, clientInfo, visible, selectedOrder, loading, sawOnlyPrixPublic } = this.state;
        const { userRole, affichePDR } = this.props;

        // Ne pas afficher le bouton si affichePDR est false
        if (!affichePDR) {
            return null;
        }

        return (
            <Fragment>
                <Modal
                    title={<FormattedMessage id="catalog.tablePdr.modal.title" />}
                    visible={visible}
                    style={{ marginLeft: 0, top: 0 }}
                    onCancel={this.onCancel}
                    onOk={this.onOk}
                    footer={[
                        <Button key="back" onClick={this.onCancel}>
                            <FormattedMessage id="common.cancel" />
                        </Button>,
                        <Button key="submit" type="danger" disabled={sawOnlyPrixPublic} onClick={this.onOk}>
                            <FormattedMessage id="catalog.tablePdr.modal.addPiece" />
                        </Button>
                    ]}
                    width="45%"
                    bodyStyle={{ height: "88vh" }}
                >
                    <div>
                        {isGroupEBV({ userRole }) ? (
                            sawOnlyPrixPublic ? (
                                <Button onClick={this.getCommandeAndCreateLine}>
                                    <FormattedMessage id="catalog.tablePdr.modal.order" />
                                </Button>
                            ) : ordersDraft.length > 0 ? (
                                <Fragment>
                                    <span id="select-category-label">
                                        <FormattedMessage id="catalog.tablePdr.modal.order" />:
                                    </span>
                                    <Select
                                        style={{ width: '100%' }}
                                        onChange={this.onOrderChanged}
                                        defaultValue={selectedOrder}
                                    >
                                        {ordersDraft &&
                                            ordersDraft.map((order) => (
                                                <Option key={order.idCommande} value={order.numCommande}>
                                                    {order.numCommande} (
                                                    {order.libelleTypeCommande}
                                                    {" - " + order.libelleDeadlines + " - "}
                                                    {moment(order.dateCreation).format('DD/MM/YYYY')} - {order.userCreated.nomPrenom}
                                                    {order.numCommandCustomer ? " - " + order.numCommandCustomer : ''}
                                                    )
                                                </Option>
                                            ))}
                                    </Select>
                                </Fragment>
                            ) : (
                                <CreateOrder refresh={this.fetchOrdersClient} client={clientInfo} />
                            )
                        ) : null}
                        <Divider />
                        <div style={{ marginTop: 8 }}>
                            <TablePDRAffichage
                                pdrDocument={pdrDocument}
                                sawOnlyPrixPublic={sawOnlyPrixPublic}
                                loading={loading}
                                updateQuantity={(rawId) => this.updateQuantity(rawId)}
                                selectedOrder={selectedOrder}
                            />
                        </div>
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

TablePDRGedCatalog.propTypes = {
    file: PropTypes.shape({
        Id: PropTypes.number.isRequired,
        Name: PropTypes.string.isRequired,
        Desc: PropTypes.string,
        IsDir: PropTypes.bool.isRequired
    }),
    affichePDR: PropTypes.bool,
    form: PropTypes.shape({
        validateFieldsAndScroll: PropTypes.func.isRequired,
        getFieldDecorator: PropTypes.func.isRequired
    }),
    intl: intlShape.isRequired,
    userRole: PropTypes.array,
    registerActions: PropTypes.func
};

const mapStateToProps = ({ app: { locale }, signIn: { clientID, userRole } }) => ({
    clientID,
    locale,
    userRole
});

export default connect(mapStateToProps)(injectIntl(Form.create()(TablePDRGedCatalog)));
